angular
  .module('bb.listing_contacts')
  .factory('ListingContactsService', ListingContactsService);

ListingContactsService.$inject = ['$resource'];
function ListingContactsService($resource) {
  const ListingContacts = $resource('/appointments/:listingId/config/contacts');

  function getListingContacts(listingId) {
    return ListingContacts.get({
      listingId,
    }).$promise;
  }

  return {
    getListingContacts,
  };
}

export {};
